<template>
  <div class="subViewMain">
    <ah-map ref="mapContainer" @map-ready="onMapReady"></ah-map>
    <router-view />
  </div>
</template>
 
<script>
import AhMap from '@/components/AhMap.vue';
export default {
  name: "subViewMain",
  components: {
    AhMap
  },
  data() {
    return {
      map: null, // 地图实例
    }
  },
  methods: {
    onMapReady(mapInstance) {
      this.map = mapInstance;
      console.log('✅ 父组件收到地图实例:', this.map);
    }
  },
  beforeUnmount() {
    this.map = null
  }
}
</script>
<style scoped lang="scss">
.subViewMain {
  position: relative;
  width: 100%;
  height: 100vh;
  background: transparent;
}

:deep(.map-container) {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1 !important;
}

:deep(.subViewMain > *) {
  position: relative;
  z-index: 10;
}
</style>